module.exports = __webpack_public_path__ + "static/media/mew-RINKEBY.da561fa4.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/ethereum/mew-RINKEBY.png
// module id = 1939
// module chunks = 147